import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { tableHandler } from '../../../../redux/handlers';

export default function EditTableModal(props) {
  const { setModalDeleteShow, handleEdit, handleDelete, formdata, ...rest } = props;

  const dispatch = useDispatch();
  const { businessSlug } = useParams();

  const schema = yup.object().shape({
    tableName: yup.string().required('กรุณากรอกชื่อโต๊ะ'),
    tableSeat: yup.string().required('กรุณากรอกจำนวนที่นั่ง')
  });

  const handleUpdateTable = async (values, { setSubmitting }) => {
    try {
      if (!values.tableID) {
        console.error('Table ID is required for update');
        return;
      }

      const payload = {
        branch_table_zone_id: values.branch_table_zone_id || formdata.branch_table_zone_id,
        name: values.tableName.trim(),
        seat_capacity: parseInt(values.tableSeat, 10)
      };

      await dispatch(tableHandler.updateBranchTable(businessSlug, values.tableID, payload));

      if (handleEdit) {
        handleEdit();
      }

      props.onHide();
    } catch (error) {
      console.error('Error updating table:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal {...rest} size="md" centered>
      <Modal.Body>
        <div className="d-flex align-items-center px-3 py-2 mb-4 pb-3">
          <div className="fs-24 fw-bold me-auto" style={{ color: '#2DC76D' }}>
            จัดการโต๊ะ
          </div>
          <button onClick={props.onHide} className="btn btn-close-modal"></button>
        </div>
        <div className="px-3">
          <Formik
            enableReinitialize
            initialValues={{
              tableID: props.formtabledata?.tableID || null,
              tableName: props.formtabledata?.tableName || '',
              tableSeat: props.formtabledata?.tableSeat || '',
              tableStatus: props.formtabledata?.tableStatus ?? 1,
              branch_table_zone_id: props.formtabledata?.branch_table_zone_id || null
            }}
            validationSchema={schema}
            onSubmit={handleUpdateTable}
          >
            {({ handleSubmit, handleChange, touched, errors, values, setFieldValue, isSubmitting }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    ชื่อโต๊ะ <span className="text-danger">*</span>{' '}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="tableName"
                    className="form-control"
                    placeholder="ชื่อโต๊ะ"
                    value={values.tableName}
                    onChange={handleChange}
                    isInvalid={!!errors.tableName}
                    disabled={isSubmitting}
                  />
                  <Form.Control.Feedback type="invalid">{errors.tableName}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    จำนวนที่นั่ง/โต๊ะ <span className="text-danger">*</span>{' '}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="tableSeat"
                    className="form-control"
                    placeholder="จำนวนที่นั่ง/โต๊ะ"
                    value={values.tableSeat}
                    onChange={handleChange}
                    isInvalid={!!errors.tableSeat}
                    disabled={isSubmitting}
                    min="1"
                  />
                  <Form.Control.Feedback type="invalid">{errors.tableSeat}</Form.Control.Feedback>
                </Form.Group>

                <Form.Label className="mb-2 tc-10">สถานะ</Form.Label>

                <div className="flex justify-content-end pt-4 mb-3 btn-group-control">
                  <Button
                    type="button"
                    className="btn-st-6 me-3"
                    style={{ width: '100px' }}
                    onClick={props.onHide}
                    disabled={isSubmitting}
                  >
                    ยกเลิก
                  </Button>
                  <Button type="submit" className="btn-st-3" style={{ width: '100px' }} disabled={isSubmitting}>
                    {isSubmitting ? 'กำลังบันทึก...' : values.tableID ? 'แก้ไข' : 'บันทึก'}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}
